import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { browserHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import Icon from '../Icon';
import Button from '../Button';
import { hideMobileAppPopup } from '../../redux/ui/popup';
import { actions as mfaNoticeActions } from '../../redux/profiles/mfa-notice';
import { PROFILE, PROFILE_SETTINGS } from '../../constants/routes';
import { targetUserIdSelector } from '../../redux/context/selectors';

import styles from './index.styl';

const MfaNoticeDialog = ({ intl }) => {
  const { formatMessage } = intl;
  const targetUserId = useSelector(targetUserIdSelector);
  const dispatch = useDispatch();

  const handleSkip = () => {
    dispatch(mfaNoticeActions.send());
    dispatch(hideMobileAppPopup());
  };
  const handleRedirect = () => {
    browserHistory.push(`/${PROFILE}/${targetUserId}/${PROFILE_SETTINGS}`);
    dispatch(hideMobileAppPopup());
  };

  return (
    <Fragment>
      <div className={styles.iconWrapper}>
        <Icon name="lock" size={48} />
      </div>
      <div className={styles.title}>
        {formatMessage({ id: 'mfa.dialog.advert.title' })}
      </div>
      <div className={styles.contentText}>
        {formatMessage({ id: 'mfa.dialog.advert.contentText' })}
      </div>
      <div className={styles.actions}>
        <Button
          onClick={handleRedirect}
          color="primary"
          raised
          className={styles.button}
        >
          {formatMessage({ id: 'mfa.dialog.activate.button' })}
        </Button>
        <Button
          color="accent"
          raised
          onClick={handleSkip}
          className={styles.button}
        >
          {formatMessage({ id: 'common.skip' })}
        </Button>
      </div>
    </Fragment>
  );
};

export default injectIntl(MfaNoticeDialog);



// WEBPACK FOOTER //
// ./src/components/MfaNoticeDialog/index.jsx